"use client";

import { USE_EZOIC } from "shared-lib/constants";

type Props = {
  children: React.ReactNode;
};

export default function EzoicDisabled({
  children,
}: React.PropsWithChildren<Props>) {
  return <>{!USE_EZOIC && children}</>;
}
